import { render, staticRenderFns } from "./addTempletConfig.vue?vue&type=template&id=08d5492b&scoped=true"
import script from "./addTempletConfig.vue?vue&type=script&lang=js"
export * from "./addTempletConfig.vue?vue&type=script&lang=js"
import style0 from "./addTempletConfig.vue?vue&type=style&index=0&id=08d5492b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5492b",
  null
  
)

export default component.exports